import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isNumber, isString } from '@partners/utils';
import { IRangeValidationHandler, TValidatorError } from '../../model';

export function maxLengthValidator(args: Partial<IRangeValidationHandler<number>>): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const { value, invalid } = control;
    const { max } = args;

    if (invalid) return null;

    if (!isString(value) || !isNumber(value?.length)) return null;

    const isHigherThenMax = value.toString().length > max;

    if (isHigherThenMax) {
      const vldResponse: TValidatorError = { maxLength: value };
      return vldResponse;
    }

    return null;
  };
}
